import { overview as base } from './base';
import { overview as AT } from './AT';
import { overview as SK } from './SK';
import { overview as HR } from './HR';
import { overview as RO } from './RO';

export const featureConfigMap = {
    base,
    AT,
    SK,
    HR,
    RO,
};
